var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"main-content"},[_c('router-view'),_c('div',{staticStyle:{"display":"none"}},[_c('local-switcher'),_c('p',[_vm._v(_vm._s(_vm.$t('bonjour')))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }